// "Download Excel" for the Generate Invoices page's Draft and Approved tables
// (LIQ-2042). Exports exactly what the table is showing: the rows its items
// provider last matched (every page, in the current sort order) and the
// columns currently visible, one cell per column.
import * as XLSX from 'xlsx'

const isBlank = (value) => value === null || value === undefined || value === ''

/**
 * @param {Object}   opts
 * @param {Array}    opts.columns    the table's visible column defs ({ key, label })
 * @param {Array}    opts.rows       the rows to export, already filtered + sorted
 * @param {Function} opts.cellValue  (columnKey, row) => the value to write for that cell
 * @param {String}   opts.sheetName
 * @param {String}   opts.filePrefix e.g. 'draft-invoices' -> draft-invoices-2026-10-19.xlsx
 */
export function downloadTableExcel({ columns, rows, cellValue, sheetName, filePrefix }) {
  const header = columns.map(c => c.label)
  const body = rows.map(row => columns.map(c => {
    const value = cellValue(c.key, row)
    return isBlank(value) ? '' : value
  }))

  const sheet = XLSX.utils.aoa_to_sheet([header, ...body])
  sheet['!cols'] = header.map((label, i) => ({
    wch: Math.min(60, Math.max(label.length, ...body.map(r => String(r[i]).length)) + 2),
  }))

  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, sheet, sheetName)
  const today = new Date().toISOString().slice(0, 10)
  XLSX.writeFile(workbook, `${filePrefix}-${today}.xlsx`)
}

// Numbers stay numeric in the sheet (so they sum/sort in Excel); blanks stay blank.
export const toNumber = (value) => (isBlank(value) || Number.isNaN(Number(value)) ? null : Number(value))
